import React from 'react';

export function AuthErrorMessage({ message }) {
  if (!message) {
    return null;
  }

  return (
    <div className="rounded-lg bg-red-50 p-3 text-center text-sm text-brand-red">
      {message}
    </div>
  );
}
